// extracted by mini-css-extract-plugin
export var activeDot = "_3z-c";
export var buttonContainer = "_3z-9";
export var channelButton = "_3z-a";
export var clickable = "_3z-d";
export var content = "_3z-0";
export var contentFull = "_3z-2";
export var contentThird = "_3z-1";
export var contentWrapper = "_3z-7";
export var description = "_3z-5";
export var heightShort = "_3z-f";
export var image = "_3z-3";
export var imageContainer = "_3z-4";
export var selectButton = "_3z-e";
export var spinnerContainer = "_3z-b";
export var titleContent = "_3z-8";
export var titleWrapper = "_3z-6";